import { render, staticRenderFns } from "./commonFlowForm.vue?vue&type=template&id=77321e78&scoped=true"
import script from "./commonFlowForm.vue?vue&type=script&lang=js"
export * from "./commonFlowForm.vue?vue&type=script&lang=js"
import style0 from "./commonFlowForm.vue?vue&type=style&index=0&id=77321e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77321e78",
  null
  
)

export default component.exports